/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Open_Artifact_Bad_IdInputs */



/**
* | output |
* | --- |
* | "This app asked to open an item with an invalid id." |
*
* @param {Canvas_Open_Artifact_Bad_IdInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_open_artifact_bad_id = /** @type {((inputs?: Canvas_Open_Artifact_Bad_IdInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Open_Artifact_Bad_IdInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese App wollte ein Element mit einer ungültigen ID öffnen.")
	return /** @type {LocalizedString} */ ("This app asked to open an item with an invalid id.")
});